const COLORS = {
  light: {
    primaryFont: "#282c34",
    primaryBackground: "#fff",
    // primaryBackground: "#f9fafb",
    tableOutline: "#282c34"
  },
  dark: {
    primaryFont: "#fff",
    primaryBackground: "#282c34",
    tableOutline: "#fff"
  }
};

export default COLORS;
